import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { ClientSharedUtilityCommonModule } from './common.module';

@Injectable({
    providedIn: ClientSharedUtilityCommonModule,
})
export class NotificationService {
    constructor(private snackBar: MatSnackBar) {}

    public show(message: string, action: string = '', duration: number = 1500) {
        this.snackBar.open(message, action, {
            duration: duration,
        });
    }
}
